<template>
  <div id="app">
    <div id="nav">
      <span v-if="isLoggedIn">
        <topbar />
        <br /><br />
        <br />
      </span>
    </div>
    <div class="container" style="padding-left:5px;padding-right:5px;">
      <router-view />
      <hr />
      <p style="font-size:10px">
        Copyright ANSI Dev Team |
        <router-link :to="{ name: 'Release Notes' }">Release Notes</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import Topbar from './components/Layout/Topbar.vue'
import AuthService from './_services/auth'

const authService = new AuthService()

export default {
  data: () => ({
    isLoggedIn: authService.isLoggedIn()
  }),
  components: {
    Topbar
  },
  created() {
    document.title = 'ANSI Payroll System'
  }
}
</script>

<style>
.checkbox-in-employee {
  float: right;
}

.table-column-content-is-small {
  font-size: 12px;
}
</style>
